"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 *  MODAL
 */
var OPEN_MODAL_EVENT = 'OPEN_MODAL_EVENT';
var MODAL_TYPE_CART = 'CART_MODAL';
var MODAL_TYPE_AUTH = 'AUTH';
var MODAL_TYPE_PUBLISH_REGISTRY = 'PUBLISH_REGISTRY';
var MODAL_TYPE_SET_SHIPPING_ADDRESS = 'SET_SHIPPING_ADDRESS';
var MODAL_TYPE_SHIPPING_EXCLUSION = 'SHIPPING_EXCLUSION'; // NOTE: Dispatched from 'Public Registry (web-registry)'

var PUBLIC_REGISTRY_EVENT = 'PUBLIC_REGISTRY_EVENT';
/**
 *  NAV V2
 */
// TODO: move this into zola helpers for reuse across repos

var NAV_LOADED = 'NAV_LOADED';
var INIT_NAV_DATA = 'INIT_NAV_DATA';
var NAV_DATA = {
  PRIMARY: {
    DASHBOARD: 'dashboard',
    REGISTRY: 'registry',
    WEBSITE: 'website',
    PAPER: 'invites',
    GUEST_LIST: 'guestList',
    WEDDING_BOUTIQUE: 'weddingBoutique',
    VENDORS: 'vendors',
    ACCOUNT: 'account'
  },
  SECONDARY: {
    REGISTRY: {
      YOUR_REGISTRY: 'your-registry',
      NEW_ARRIVALS: 'new-arrivals',
      COLLECTIONS: 'collections',
      BRANDS: 'brands',
      EXPERIENCES: 'experiences',
      CASH_FUNDS: 'cash-funds'
    },
    WEDDINGS: {
      GUEST_LIST: 'guest-list',
      EVENTS: 'events',
      CHECKLIST: 'wedding-checklist',
      REAL_WEDDINGS: 'real-weddings',
      VENDORS: 'inspire-wedding-vendors',
      EXPERT_ADVICE: 'expert-advice'
    },
    PAPER: {
      INVITATION: 'invitations',
      SAVE_THE_DATE: 'save-the-date',
      CHANGE_THE_DATE: 'change-the-date',
      THANK_YOU: 'thank-you-cards',
      MENU: 'menus',
      DETAILS: 'enclosures',
      PROGRAM: 'programs',
      HOLIDAY: 'holiday-cards',
      PROJECTS: 'projects'
    },
    GUEST_LIST: {
      ALL_GUESTS: 'guests',
      BUILD: 'build',
      ENVELOPES: 'envelopes',
      TRACK_RSVPS: 'rsvp-overview',
      RSVP_REQUESTS: 'rsvp-notifications'
    },
    WEBSITE: {
      MANAGE: 'manange',
      EDIT: 'edit',
      DESIGNS: 'designs'
    },
    MARKETPLACE: {
      EXPLORE_VENDORS: 'marketplace-vendors',
      VENDOR_CONNECTIONS: 'marketplace-connections',
      BOOKED_VENDORS: 'marketplace-booked-vendors',
      BECOME_VENDOR: 'marketplace-become-vendor'
    }
  },
  EVENTS: {
    OPEN_MODAL_EVENT: OPEN_MODAL_EVENT,
    MODAL_TYPE_CART: MODAL_TYPE_CART,
    MODAL_TYPE_AUTH: MODAL_TYPE_AUTH,
    MODAL_TYPE_PUBLISH_REGISTRY: MODAL_TYPE_PUBLISH_REGISTRY,
    MODAL_TYPE_SET_SHIPPING_ADDRESS: MODAL_TYPE_SET_SHIPPING_ADDRESS,
    MODAL_TYPE_SHIPPING_EXCLUSION: MODAL_TYPE_SHIPPING_EXCLUSION,
    NAV_LOADED: NAV_LOADED,
    INIT_NAV_DATA: INIT_NAV_DATA,
    PUBLIC_REGISTRY_EVENT: PUBLIC_REGISTRY_EVENT
  }
};
var _default = NAV_DATA;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@zola-helpers/client/dist/es/constants/navConstants.js
// module id = 1055
// module chunks = 47